export const objectToMission = (item) => {
    return {
        id: +item.id,
        type: item.type,
        name: item.name,
        slug: item.slug,
        groupName: item.group_name,
        missionGoal: item.mission_goal,
        startDate: item.started,
        distanceUnit: item.distance_unit,
        isConqueror: false,
        exerciseTypes: item.exercise_types.map((e) => e.alias2),
        imgAvatar: item.avatar_image,
        distancePct: item.distance_pct,
        isFundraising: item.is_fundrasing,
        participantsCt: item.participants,
    };
};
export const collectionToTeams = (items) => {
    return items.map((item) => ({
        id: item.id,
        name: item.name,
        numUsers: item.num_users,
        imageExtension: item.image_extension,
    }));
};
export const collectionToParticipants = (items) => {
    return items.map((item) => ({
        id: item.user_id,
        email: item.email,
        firstName: item.first_name,
        lastName: item.last_name,
        imagePath: item.image_path,
    }));
};
